import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  Card,
  Button,
  Tab,
  Tabs,
  Collapse,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { m, LazyMotion, domAnimation } from "framer-motion";

const AboutUs = () => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("0");
  const [open, setOpen] = useState(false);

  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <LazyMotion features={domAnimation}>
      <section className="py-5 about-us" id="aboutus">
        <Container>
          <m.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
            style={{ willChange: "opacity" }}
          >
            <Row className="text-center mb-lg-5 mb-4">
              <Col>
                <h2
                  className="text-center mb-2 feature-title"
                  style={{ color: "var(--primary-color)" }}
                >
                  {t("aboutUs.title")}
                </h2>
                <p
                  className="hero-description text-dark"
                  style={{ color: "var(--text-dark)" }}
                >
                  {t("aboutUs.description")}
                </p>
              </Col>
            </Row>
          </m.div>

          <m.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <Row>
              <Col className="mb-lg-5 mb-4">
                <Tabs
                  activeKey={activeKey}
                  onSelect={(k) => setActiveKey(k)}
                  className="mb-3 about-tabs"
                >
                  <Tab eventKey="0" title={t("aboutUs.tabs.creators")}>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="accordion-header-about">
                          {t("aboutUs.creatorsTitle")}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="aboutUs-Description">
                            {t("aboutUs.creatorsDescription")}
                          </p>
                          <p className="aboutUs-Description mb-3">
                            {t("aboutUs.creatorsDescription2")}
                          </p>
                          <strong className="about_strongtxt">
                            {t("aboutUs.teamLabel")}:
                          </strong>
                          <ul>
                            <li className="about_listtxt1">
                              {t("aboutUs.team.aboutTeamName1")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.team.aboutTeamName2")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.team.aboutTeamName3")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.team.aboutTeamName4")}
                            </li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Tab>

                  <Tab eventKey="1" title={t("aboutUs.tabs.mission")}>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="accordion-header-about">
                          {t("aboutUs.missionTitle")}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="aboutUs-Description">
                            {t("aboutUs.missionDescription")}
                          </p>
                          <p className="aboutUs-Description mb-3">
                            {t("aboutUs.missionDescription2")}
                          </p>
                          <strong className="about_strongtxt">
                            {t("aboutUs.missionKeyAspects")}:
                          </strong>
                          <ul>
                            <li className="about_listtxt1">
                              {t("aboutUs.mission.aspect1")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.mission.aspect2")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.mission.aspect3")}
                            </li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Tab>

                  <Tab eventKey="2" title={t("aboutUs.tabs.vision")}>
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header className="accordion-header-about">
                          {t("aboutUs.visionTitle")}
                        </Accordion.Header>
                        <Accordion.Body>
                          <p className="aboutUs-Description">
                            {t("aboutUs.visionDescription")}
                          </p>
                          <p className="aboutUs-Description mb-3">
                            {t("aboutUs.visionDescription2")}
                          </p>
                          <strong className="about_strongtxt">
                            {t("aboutUs.visionLongTerm")}:
                          </strong>
                          <ul>
                            <li className="about_listtxt1">
                              {t("aboutUs.vision.item1")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.vision.item2")}
                            </li>
                            <li className="about_listtxt1">
                              {t("aboutUs.vision.item3")}
                            </li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </m.div>

          <m.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <Row>
              <Col className="mb-lg-5 mb-4">
                <h3
                  className="headingText2 mb-lg-3 mb-2"
                  style={{ color: "var(--primary-color)" }}
                >
                  {t("aboutUs.spiritualTitle")}
                </h3>
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="accordion-header-about">
                      {t("aboutUs.malaChantingTitle")}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="aboutUs-Description">
                        <strong>{t("aboutUs.nityaMala")}</strong>
                        {t("aboutUs.pathToPeace")}
                        <br />
                        {t("aboutUs.malaChantingDescription")}
                        <br />
                        {t("aboutUs.stayConsistent")}
                        <br />
                        {t("aboutUs.dailyPractice")}
                        <br />
                        {t("aboutUs.regularChanting")}
                        <br />
                        {t("aboutUs.spiritualPath")}
                        <br />
                        <br />
                        <strong>{t("aboutUs.importanceOfChanting")} -</strong>
                        <br />
                        {t("aboutUs.malaChantingDetails")}
                        <br />
                        {t("aboutUs.malaChantingDetails2")}
                        <br />
                        {t("aboutUs.malaChantingDetails3")}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </m.div>

          <Row>
            {[
              {
                titleKey: "aboutUs.howToPerform",
                content: (
                  <ol>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep1")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep2")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep3")}
                    </li>
                    <li className="about_listtxt1">
                      {t("aboutUs.practiceStep4")}
                    </li>
                  </ol>
                ),
              },
              {
                titleKey: "aboutUs.why108Beads",
                content: (
                  <p className="aboutUs-Description">
                    {t("aboutUs.why108Description")}
                  </p>
                ),
              },
              {
                titleKey: "aboutUs.typesOfMalas",
                content: (
                  <ol>
                    <li className="about_listtxt1">{t("aboutUs.mala1")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala2")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala3")}</li>
                    <li className="about_listtxt1">{t("aboutUs.mala4")}</li>
                  </ol>
                ),
              },
              {
                titleKey: "aboutUs.benefitsTitle",
                content: (
                  <ul>
                    <li className="about_listtxt1">{t("aboutUs.benefit1")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit2")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit3")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit4")}</li>
                    <li className="about_listtxt1">{t("aboutUs.benefit5")}</li>
                  </ul>
                ),
              },
            ].map((item, index) => (
              <Col md={6} className="mb-4" key={index}>
                <m.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  variants={sectionVariants}
                  transition={{ delay: index * 0.1 }}
                  className="h-100"
                >
                  <Card
                    className="about-infocard border-0 h-100"
                    style={{
                      borderRadius: "12px",
                      boxShadow: "var(--shadow-sm)",
                      backgroundColor: "var(--secondary-color)",
                      transition: "box-shadow 0.3s ease",
                    }}
                  >
                    <Card.Body>
                      <Card.Title style={{ color: "var(--primary-color)" }}>
                        {t(item.titleKey)}
                      </Card.Title>
                      <Card.Text as="div">{item.content}</Card.Text>
                    </Card.Body>
                  </Card>
                </m.div>
              </Col>
            ))}
          </Row>

          <m.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.1 }}
            variants={sectionVariants}
          >
            <Row>
              <Col>
                <Button
                  onClick={() => setOpen(!open)}
                  aria-controls="collapse-text"
                  aria-expanded={open}
                  className="learn-more-btn border-0 text-light"
                  style={{ backgroundColor: "var(--primary-color)" }}
                >
                  {t("aboutUs.learnMoreBtn")}
                </Button>

                <Collapse in={open}>
                  <div
                    id="collapse-text"
                    className="mt-3 p-4 collapse-content rounded-3"
                    style={{ backgroundColor: "var(--white)" }}
                  >
                    <div className="aboutUs-Description">
                      <p className="mb-lg-3 mb-2">{t("aboutUs.learnMoreText1")}</p>
                      <p className="mb-lg-3 mb-2">{t("aboutUs.learnMoreText2")}</p>
                      <p className="mb-lg-3 mb-2">
                        {t("aboutUs.nityaMalaPowerful")}
                      </p>
                      <p className="mb-lg-3 mb-2">
                        {t("aboutUs.nityaMalaPowerful2")}
                      </p>
                      <p className="mb-lg-3 mb-2"> {t("aboutUs.startToday")}</p>
                      <p className="mb-lg-3 mb-2"> {t("aboutUs.startToday2")}</p>
                      <p className="mb-lg-3 mb-2">
                        {t("aboutUs.strengthenSpiritualPath")}
                      </p>
                    </div>
                  </div>
                </Collapse>
              </Col>
            </Row>
          </m.div>
        </Container>
      </section>
    </LazyMotion>
  );
};

export default AboutUs;
